// extracted by mini-css-extract-plugin
export default {"conatiner":"_1cffogf","carousel-container":"_1nqoxzg","carouselContainer":"_1nqoxzg","carousel":"_mqd0rc"};